import type { FC } from 'react';
import React from 'react';
import type { DropdownMenuPortalProps as RadixDropdownMenuPortalProps } from '@radix-ui/react-dropdown-menu';
import { Portal } from '@radix-ui/react-dropdown-menu';

type DropdownMenuPortalProps = RadixDropdownMenuPortalProps;

const DropdownMenuPortal: FC<DropdownMenuPortalProps> = ({ children, ...props }) => (
	<Portal {...props}>{children}</Portal>
);

export default DropdownMenuPortal;
